import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { Guid } from "../../../../../../../../react-core/Utils/Guid";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { CorporateActionModel } from "../../../../../../../../Wrap/Models/Domains/Transactions/CorporateAction/CorporateActionModel";
import { PortfolioDashboardStore } from "../../../Store/Variable";
import { Contents } from "../Resource/Contents";

interface ICorporateActionsPopupViewProps {
    showBox: boolean;
    corpActionType: string;
    onChange: (val: boolean) => void;
    data: CorporateActionModel;
    selectedSubAccount: string;
}

export class CorporateActionsPopupView extends FormComponent<ICorporateActionsPopupViewProps, {}> {
    constructor(props: ICorporateActionsPopupViewProps) {
        super(props);
    }

    private renderModal(): JSX.Element {
        return (
            <Lightbox
                show={this.props.showBox}
                title={this.getTitle()}
                contentAfterTitle={null}
                onClose={() => this.props.onChange(false)}
                type={LightboxType.Modal}
                unclosable={false}
                noOverlay={false}
                noAutofocus={false}
                cssWrapper={"is-default-lightbox"}
            >
                {this.getModalBody()}
            </Lightbox>
        );
    }

    private getTitle() {
        const { data, corpActionType } = this.props;
        const allAccounts = PortfolioDashboardStore.getData();

        let clientInfo;
        allAccounts.forEach((x) => {
            if (x.HierarchyId == this.props.selectedSubAccount) {
                clientInfo = x;
                return;
            } else if (x.SubAccounts.find((s) => s.HierarchyId == this.props.selectedSubAccount)) {
                clientInfo = x;
                return;
            }
        });

        if (corpActionType) {
            return "Dividend detail - " + clientInfo.AccountName + " " + data.ClAccountID;
        } else {
            return "Other corporate action detail - " + clientInfo.AccountName + " " + data.ClAccountID;
        }
    }

    private getModalBody(): JSX.Element {
        const { data, corpActionType } = this.props;
        return (
            <div className="content">
                {corpActionType ? this.renderCorpAction() : this.renderOtherCorpAction()}
                <div className="row">{this.renderNotes()}</div>
            </div>
        );
    }

    private renderCorpAction() {
        const { data } = this.props;
        return (
            <>
                <div>
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th colSpan={2}>Dividend details</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>Instrument code:</th>
                                <td>{data.InstrumentCode + "(" + data.Description + ")"}</td>
                            </tr>
                            <tr>
                                <th>Corporate action ID:</th>
                                <td>{data.CorpActID}</td>
                            </tr>
                            {this.renderAutoTemplate("Ex-Date Holding:", data.ExDateHolding, true)}
                            <tr>
                                <th>Ex-dividend date:</th>
                                <td>{JsonDateParser.getFormatDate(data.ExDate, "dd/MM/yyyy")}</td>
                            </tr>
                            <tr>
                                <th>Dividend rate:</th>
                                <td>
                                    {data.CCY}
                                    {MoneyDisplayHelper.FromatMoneyDisplay(Math.abs(data.DivRate), null, false, 4)}
                                </td>
                            </tr>
                            <tr>
                                <th>Payment date:</th>
                                <td>{JsonDateParser.getFormatDate(data.PostDate, "dd/MM/yyyy")}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th colSpan={2}>Payment details*</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>Declared dividend:</th>
                                <td>{data.DivDeclared}</td>
                            </tr>
                            {this.renderAutoTemplate("Imputation credit:", data.DivImptCredit)}
                            {this.renderAutoTemplate("Dividend withholding payment:", data.DivWithPayment)}
                            {this.renderCont()}
                            {this.renderAutoTemplate("Misc. charges:", data.MiscCharges)}
                            {this.renderAutoTemplate("Dividend payable:", data.DivPayable, true)}
                        </tbody>
                    </table>
                </div>
            </>
        );
    }

    private renderOtherCorpAction() {
        const { data } = this.props;
        return (
            <>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th colSpan={2}>Capital Reconstruction Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>Instrument code:</th>
                            <td>{data.InstrumentCode + "(" + data.Description + ")"}</td>
                        </tr>
                        <tr>
                            <th>Corporate action ID:</th>
                            <td>{data.Id}</td>
                        </tr>
                        {this.renderAutoTemplate("Ex-Date holding:", data.ExDateHolding, true)}
                        <tr>
                            <th>Exdate:</th>
                            <td>{JsonDateParser.getFormatDate(data.ExDate, "dd/MM/yyyy")}</td>
                        </tr>
                        <tr>
                            <th>Effective date:</th>
                            <td>{JsonDateParser.getFormatDate(data.ExerciseDate, "dd/MM/yyyy")}</td>
                        </tr>
                        <tr>
                            <th>Ratio:</th>
                            <td>{data.Ratio}</td>
                        </tr>
                        <tr>
                            <th>Cash amount per share:</th>
                            <td>
                                {data.CCY}
                                {MoneyDisplayHelper.FromatMoneyDisplay(
                                    Math.abs(data.CapReconCashAmountPerShare),
                                    null,
                                    false,
                                    2
                                )}
                            </td>
                        </tr>
                        {this.renderAutoTemplate("Shares cancelled:", data.CapReconCancelled, true)}
                        {this.renderAutoTemplate("Total new holding:", data.CapReconNewHolding, true)}
                    </tbody>
                </table>
            </>
        );
    }

    private renderCont() {
        const { data } = this.props;
        if (data.ClCoyCtryCode && data.ClCoyCtryCode.toUpperCase() == "GBR") {
            return this.renderAutoTemplate("Withholding tax:", data.DivFWT + data.DivRwt, true);
        } else if (data.DivFWT > 0) {
            return this.renderAutoTemplate("Foreign withholding tax:", data.DivFWT, true);
        }
    }

    private renderAutoTemplate(title, value: number, isAlwaysRender?: boolean): JSX.Element {
        if (isAlwaysRender) {
            return (
                <tr>
                    <th>{title}</th>
                    <td>{this.getMoneyFormat(value)}</td>
                </tr>
            );
        } else if (value > 0) {
            return (
                <tr>
                    <th>{title}</th>
                    <td>{this.getMoneyFormat(value)}</td>
                </tr>
            );
        } else {
            return null;
        }
    }

    private getMoneyFormat(val: number): string {
        const formatMoney = MoneyDisplayHelper.FromatMoneyDisplay(Math.abs(val), null, false, 2);
        return formatMoney;
    }

    private renderNotes() {
        const { data, corpActionType } = this.props;
        const element = [];
        if (data.Notes) {
            element.push(
                <div key={Guid.getNext()}>
                    <p>{data.Notes}</p>
                </div>
            );
        }
        if (corpActionType) {
            if (data.Status && data.Status.toUpperCase() != "POSTED") {
                element.push(
                    <div key={Guid.getNext()}>
                        <p>{Contents.DividendNotes}</p>
                    </div>
                );
            }
        } else {
            element.push(
                <>
                    <div>
                        <p>{Contents.ImportantNotes}</p>
                    </div>
                    <div>
                        <p>{Contents.SubNotes}</p>
                    </div>
                </>
            );
        }

        return element;
    }

    public render(): JSX.Element {
        return <>{this.props.showBox ? this.renderModal() : null}</>;
    }
}
